import React from "react";
import Item from "./Item";
import StyleWrapper from "./StyleWrapper";
import iconPie from "../../images/icon-pie.js";
import iconPieActive from "../../images/icon-pie-active.js";
import iconMan from "../../images/icon-man.js";
import iconManActive from "../../images/icon-man-active.js";
import iconStar from "../../images/icon-star.js";
import iconStarActive from "../../images/icon-star-active.js";
import iconTrend from "../../images/icon-trend.js";
import iconTrendActive from "../../images/icon-trend-active.js";
import iconYen from "../../images/icon-yen.js";
import iconYenActive from "../../images/icon-yen-active.js";

const Footer = () => {
    return (
        <StyleWrapper>
            <Item
                to="/"
                figure={iconPie}
                figureActive={iconPieActive}
                title="首页"
            />
            <Item
                to="/trade/selection"
                figure={iconStar}
                figureActive={iconStarActive}
                title="自选"
            />
            <Item
                to="/trade/market/index"
                figure={iconTrend}
                figureActive={iconTrendActive}
                title="行情"
            />
            <Item
                to="/trade/account/index"
                figure={iconYen}
                figureActive={iconYenActive}
                title="交易"
            />
            <Item
                to="/member/index"
                figure={iconMan}
                figureActive={iconManActive}
                title="我的"
            />
        </StyleWrapper>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js


// WEBPACK FOOTER //
// ./src/components/Footer/index.js